export default {
  NAME: 'shintaro',
  getStorage: function () {
    const json = sessionStorage.getItem(this.NAME)
    return json ? JSON.parse(json) : {}
  },
  setStorage: function (obj) {
    sessionStorage.setItem(this.NAME, JSON.stringify(obj))
  },
  get: function (key, default_) {
    const obj = this.getStorage()
    return key in obj ? obj[key] : default_ !== undefined ? default_ : null
  },
  set: function (key, val) {
    const obj = this.getStorage()
    obj[key] = val
    this.setStorage(obj)
  },
  remove: function (key) {
    const obj = this.getStorage()
    if (key in obj) delete obj[key]
    this.setStorage(obj)
  },
  removeAll: function () {
    sessionStorage.clear()
  }
}
